import { createSlice } from "@reduxjs/toolkit";
import { ILiquidityLog, ITransactionLog } from "api/types/_monitoring";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { getLiquidityLogs, getTransactionLogs } from "./thunk";


export interface IState {
  liquidityLogs: ResponseData<ILiquidityLog[]> & PaginationResponse | null,
  isLiquidityLogLoading: boolean,
  isLiquidityLogSuccess: boolean,

  transactionLogs: ResponseData<ITransactionLog[]> & PaginationResponse | null,
  isTransactionLogLoading: boolean,
  isTransactionLogSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  liquidityLogs: null,
  isLiquidityLogLoading: false,
  isLiquidityLogSuccess: false,

  transactionLogs: null,
  isTransactionLogLoading: false,
  isTransactionLogSuccess: false,

  error: {},
};

const MonitoringSlice = createSlice({
  name: "Monitoring",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get LiquidityLogs
    builder.addCase(getLiquidityLogs.pending, (state: IState, action: any) => {
      state.isLiquidityLogLoading = true
    });
    builder.addCase(getLiquidityLogs.fulfilled, (state: IState, action: any) => {
      state.liquidityLogs = action.payload;
      state.isLiquidityLogSuccess = true;
      state.isLiquidityLogLoading = false;
    });
    builder.addCase(getLiquidityLogs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isLiquidityLogSuccess = false;
      state.isLiquidityLogLoading = false;
    });

    //get TransactionLogs
    builder.addCase(getTransactionLogs.pending, (state: IState, action: any) => {
      state.isTransactionLogLoading = true
    });
    builder.addCase(getTransactionLogs.fulfilled, (state: IState, action: any) => {
      state.transactionLogs = action.payload;
      state.isTransactionLogSuccess = true;
      state.isTransactionLogLoading = false;
    });
    builder.addCase(getTransactionLogs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isTransactionLogSuccess = false;
      state.isTransactionLogLoading = false;
    });
  },
});

export default MonitoringSlice.reducer;